import api from "api";
import { useMutation } from "react-query";

export interface DeleteExerciseVars {
  id: number;
}

export const useDeleteExercise = () =>
  useMutation((data: DeleteExerciseVars) => {
    // @ts-ignore
    return api("DELETE /exercises/{id}", {
      params: [data.id],
      root: process.env.REACT_APP_API_URL_V2 + "/v2/support",
    });
  });
